(() => {
  const initialize = (scope = document) => {
    const containers = scope.matches?.('[data-comic-article]')
      ? [scope]
      : scope.querySelectorAll('[data-comic-article]');
    containers.forEach((container) => {
      const from = new URL(window.location.href).searchParams.get('from');
      if (!from || !from.startsWith('/') || from.startsWith('//') || from.includes('\\')) return;
      try {
        const destination = new URL(from, window.location.origin);
        const archive = new URL(container.dataset.comicBlog, window.location.origin);
        const taggedPrefix = `${archive.pathname}/tagged/`;
        const isArchive = destination.pathname === archive.pathname || destination.pathname === `${archive.pathname}/`;
        const isTagged = destination.pathname.startsWith(taggedPrefix) && destination.pathname.slice(taggedPrefix.length).length > 0;
        if (destination.origin !== window.location.origin || (!isArchive && !isTagged)) return;
        destination.hash = '';
        container.querySelectorAll('[data-comic-back]').forEach((link) => {
          link.href = `${destination.pathname}${destination.search}`;
        });
      } catch {
        return;
      }
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
